//
export default [
    {
        name: 'wh_product_name',
        type: 'text-field',
        flex: {
            xs12: true,
            sm8: true,
        },
        props: {
            label: 'Producto',
        },
    },
    {
        name: 'wh_warehouse_name',
        type: 'text-field',
        flex: {
            xs12: true,
            sm4: true,
        },
        props: {
            label: 'Bodega',
        },
    },
    {
        name: 'details',
        type: 'table-field',
        flex: {
            xs12: true,
        },
        props: {
            headers: [
                {
                    text: 'Nombre',
                    value: 'text',
                },
                {
                    text: 'Valor',
                    value: 'value',
                    align: 'right',
                    format: 'number',
                },
            ],
            toolbarTitle: 'Detalles',
        },
    },
    {
        name: 'created_at',
        type: 'date-field',
        props: {
            label: 'Fecha',
        },
    },
    {
        name: 'input_total',
        type: 'float-field',
        props: {
            label: 'Entrada',
        },
    },
    {
        name: 'output_total',
        type: 'float-field',
        props: {
            label: 'Salida',
        },
    },
    {
        name: 'input_output_total',
        type: 'float-field',
        props: {
            label: 'Total',
        },
    },
]
